export const DIAL_CODES: { code: string; label: string }[] = [
  { code: '+91', label: 'IN +91' },
  { code: '+1', label: 'US/CA +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+971', label: 'AE +971' },
  { code: '+65', label: 'SG +65' },
  { code: '+61', label: 'AU +61' },
  { code: '+49', label: 'DE +49' },
  { code: '+33', label: 'FR +33' },
  { code: '+81', label: 'JP +81' },
  { code: '+86', label: 'CN +86' },
  { code: '+92', label: 'PK +92' },
  { code: '+880', label: 'BD +880' },
  { code: '+94', label: 'LK +94' },
  { code: '+977', label: 'NP +977' },
  { code: '+966', label: 'SA +966' },
  { code: '+27', label: 'ZA +27' },
  { code: '+234', label: 'NG +234' },
  { code: '+55', label: 'BR +55' },
  { code: '+52', label: 'MX +52' },
];

const COUNTRY_DIAL: Record<string, string> = {
  IN: '+91', US: '+1', CA: '+1', GB: '+44', AE: '+971', SG: '+65', AU: '+61', DE: '+49', FR: '+33',
  JP: '+81', CN: '+86', PK: '+92', BD: '+880', LK: '+94', NP: '+977', SA: '+966', ZA: '+27',
  NG: '+234', BR: '+55', MX: '+52',
};

/** Dial code to preselect for a visitor's IP country: its own code (+91 for India); +91 when unknown, as on signup. */
export const defaultDialCode = (country: string | null | undefined): string =>
  COUNTRY_DIAL[(country ?? '').toUpperCase()] ?? '+91';
